<template>
  <div class="login-page">
    <div class="grid-shell">
      <!-- Left -->
      <section class="left">
        <img class="logo" src="@/assets/logo_marketing.png" alt="LYON logo" />

        <div class="greeting">
          <h1>Hi,</h1>
          <h1>Welcome Back</h1>
        </div>

        <div v-if="error" class="err-box">
          {{ error }}
        </div>

        <form class="form" @submit.prevent="handleLogin" novalidate>
          <!-- Email -->
          <label class="field">
            <span class="label">Email</span>
            <input
              v-model.trim="email"
              type="email"
              placeholder="Enter your email"
              autocomplete="username"
              required
            />
          </label>

          <!-- Password -->
          <label class="field">
            <span class="label">Password</span>
            <div class="password-wrap">
              <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter password"
                autocomplete="current-password"
                required
              />
              <button
                type="button"
                class="eye"
                :aria-pressed="showPassword ? 'true' : 'false'"
                @click="togglePassword"
                title="Toggle password visibility"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path
                    v-if="!showPassword"
                    fill="currentColor"
                    d="M12 4.5c5.5 0 9.7 4.4 10.7 6-1 1.6-5.2 6-10.7 6S2.3 12.1 1.3 10.5c1-1.6 5.2-6 10.7-6zm0 2c-3.9 0-7.3 2.7-8.8 4.1 1.5 1.4 4.9 4.1 8.8 4.1s7.3-2.7 8.8-4.1C19.3 9.2 15.9 6.5 12 6.5zm0 1.8a3.7 3.7 0 1 1 0 7.4 3.7 3.7 0 0 1 0-7.4z"
                  />
                  <path
                    v-else
                    fill="currentColor"
                    d="M3.3 2.9 2 4.2l4 4C3.8 9.3 2.4 10.9 1.3 12.5c1 1.6 5.2 6 10.7 6 2.2 0 4.1-.5 5.7-1.2l4.3 4.3 1.3-1.3L3.3 2.9zM8.8 9l1.3 1.3a3.7 3.7 0 0 0 4.6 4.6l1.3 1.3c-.9.4-2 .6-3 .6-3.9 0-7.3-2.7-8.8-4.1.7-.7 1.7-1.6 3-2.4L8.8 9zm3.2-.9c1.7 0 3.2 1.4 3.2 3.2 0 .3 0 .6-.1.9l1.6 1.6c.3-.7.5-1.6.5-2.5a5.2 5.2 0 0 0-5.2-5.2c-.9 0-1.7.2-2.5.5l1.6 1.6c.3-.1.6-.1.9-.1z"
                  />
                </svg>
              </button>
            </div>
          </label>

          <div class="form-bottom">
            <button type="button" class="link" @click.prevent>
              Forgot password?
            </button>
          </div>

          <!-- Submit -->
          <button class="primary mt-6" type="submit" :disabled="loading">
            <span v-if="!loading">Login</span>
            <span v-else>Logging in…</span>
          </button>
        </form>
      </section>

      <!-- Right -->
      <section class="right">
        <div class="art-card">
          <img src="@/assets/Login.png" alt="Login Illustration" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      loading: false,
      error: null,
    };
  },
  methods: {
    ...mapActions(["loginUser"]),

 async handleLogin() {
  this.loading = true;
  this.error = null;

  try {
    console.log("payload", { email: this.email, password: this.password });

    await this.loginUser({ email: this.email, password: this.password });
    this.$router.push("/customers");
  } catch (err) {
    console.log("LOGIN ERROR:", err);
    const data = err?.response?.data;

    this.error =
      data?.message ||
      (data?.errors ? Object.values(data.errors).flat().join(" | ") : null) ||
      err?.message ||
      "Login failed.";
  } finally {
    this.loading = false;
  }
},


    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #ffffff;
  display: grid;
  place-items: center;
  padding: 24px;
}

.grid-shell {
  width: 100%;
  max-width: 1120px;
  display: grid;
  grid-template-columns: 1fr 0.75fr;
  gap: 36px;
  align-items: start;
}

.left { padding-top: 8px; }
.logo { display: block; width: 120px; margin: 0 auto 22px; user-select: none; }

.greeting h1 {
  margin: 0;
  color: #111827;
  line-height: 1.1;
  font-size: 36px;
  font-weight: 700;
}
.greeting h1 + h1 { margin-top: 4px; }

.form { margin-top: 22px; max-width: 420px; }

.field { display: block; margin-bottom: 16px; }
.label {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin-bottom: 6px;
}

.field input {
  width: 100%;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #fff;
}
.field input::placeholder { color: #b9c1cc; }
.field input:focus {
  border-color: #b7c7d6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

/* password eye */
.password-wrap { position: relative; }
.password-wrap input { padding-right: 36px; }
.eye {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  border-radius: 6px;
}
.eye:hover { background: #f3f4f6; }

/* bottom row */
.form-bottom {
  display: flex;
  justify-content: flex-start;
  margin-top: 4px;
  margin-bottom: 10px;
}
.link {
  font-size: 12px;
  color: #3b82f6;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
}

/* submit */
.primary {
  width: 100%;
  height: 40px;
  border-radius: 999px;
  background: #5b9ac5;
  color: #fff;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  transition: filter 0.2s, transform 0.02s;
}
.primary:hover { filter: brightness(0.96); }
.primary:disabled { opacity: 0.6; cursor: not-allowed; }

/* error box */
.err-box {
  margin-top: 14px;
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(239, 68, 68, 0.10);
  color: #ef4444;
  font-size: 13px;
}

/* right */
.right img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 14px;
}

/* responsive */
@media (max-width: 1024px) {
  .grid-shell { grid-template-columns: 1fr 0.9fr; gap: 28px; }
}
@media (max-width: 860px) {
  .grid-shell { grid-template-columns: 1fr; max-width: 560px; }
  .right { display: none; }
  .greeting h1 { font-size: 32px; }
}

/* hide edge reveal buttons */
.password-wrap input[type="password"]::-ms-reveal,
.password-wrap input[type="password"]::-ms-clear {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.password-wrap input[type="password"]::-webkit-textfield-decoration-container,
.password-wrap input[type="password"]::-webkit-credentials-auto-fill-button,
.password-wrap input[type="password"]::-webkit-contacts-auto-fill-button,
.password-wrap input[type="password"]::-webkit-clear-button {
  display: none !important;
}
.password-wrap input {
  -webkit-appearance: none;
  appearance: none;
}
</style>
